import React from 'react';
import InlineSVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom'; // For navigation

import systemAlertSvg from 'style/assets/icon-system-alert.svg';
import systemOkSvg from 'style/assets/icon-system-ok.svg';
import { PATH_STATUS, PATH_OPERATIONS } from 'common/constants';

import { SystemStatusBtnWrapper } from './SystemStatusBtn.styles';
import { useRematchSelector } from 'models/rematchStore';

export const SystemStatusBtnView = () => {
    const systems = useRematchSelector((state) => state.systemStatus.systems);
    const isActive = useRematchSelector((state) => state.routing.pathname.includes(PATH_STATUS));
    const selectedPark = useRematchSelector((state) => state.appData.selectedPark);

    const navigate = useNavigate();

    const toggleStatusPage = () => {
        const pathname = isActive ? PATH_OPERATIONS : PATH_STATUS;
        navigate(`/${selectedPark.toLowerCase()}/${pathname}`); // Using navigate for routing
    };

    const handleLinkClick = () => {
        if (toggleStatusPage !== undefined) {
            toggleStatusPage();
        }
    };

    const statusData = systems || [];

    const serverStatuses = statusData.map((d) => d.status).filter((d) => d !== 'Operational');

    const systemIcon = serverStatuses.length === 0 && statusData.length > 0 ? systemOkSvg : systemAlertSvg;
    return (
        <SystemStatusBtnWrapper>
            <div onClick={handleLinkClick} role="link">
                <InlineSVG className="system-status-icon" src={systemIcon} />
            </div>
        </SystemStatusBtnWrapper>
    );
};
